module.exports = __webpack_public_path__ + "static/img/cus_02_pre.92895e82.jpg";